export const reportGitlabIssue = (title: string, description: string) => {
  const formattedTitle = encodeURIComponent(title)
  const formattedDescription = encodeURIComponent(description)
  window.open(`https://git.knitiv.net/knitiv/front5/-/issues/new?issue[title]=${formattedTitle}&issue[description]=${formattedDescription}`)
}
